<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">
    <form [formGroup]="programacionForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Cliente *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <input type="text"
                   placeholder="Seleccionar Cliente"
                   matInput
                   formControlName="clientId"
                   [matAutocomplete]="auto"
                   (focus)="onClienteFocus()"
                   (input)="filtrarClientes($event)">
            <mat-autocomplete #auto="matAutocomplete" 
                            [displayWith]="displayFn"
                            [autoActiveFirstOption]="true"
                            (opened)="onClienteFocus()">
              <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente.id">
                {{ cliente.nombre }}
              </mat-option>
            </mat-autocomplete>
            @if (programacionForm.get('clientId')?.touched && programacionForm.get('clientId')?.invalid) {
            <mat-error>
              {{ getErrorMessage('clientId') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Local *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <input type="text"
                   placeholder="Seleccionar Local"
                   matInput
                   formControlName="localId"
                   [matAutocomplete]="autoLocal"
                   (focus)="onLocalFocus()"
                   (input)="filtrarLocales($event)">
            <mat-autocomplete #autoLocal="matAutocomplete" 
                            [displayWith]="displayLocalFn"
                            [autoActiveFirstOption]="true"
                            (opened)="onLocalFocus()">
              <mat-option *ngFor="let local of filteredLocales | async" [value]="local.id">
                {{ local.nombre_local }}
              </mat-option>
            </mat-autocomplete>
            @if (programacionForm.get('localId')?.touched && programacionForm.get('localId')?.invalid) {
            <mat-error>
              {{ getErrorMessage('localId') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <!-- Selección de Activos Fijos (condicional) -->
      <div class="row" *ngIf="puedeSeleccionarActivos()">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Activos Fijos *</mat-label>
        </div>
        <div class="col-sm-8">
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
            <button mat-raised-button color="accent" type="button" (click)="abrirSelectorActivos()">
              <mat-icon>assignment</mat-icon>
              {{ activosSeleccionados.length > 0 ? 'Modificar Selección' : 'Seleccionar Activos' }}
            </button>
            <mat-chip-set *ngIf="activosSeleccionados.length > 0">
              <mat-chip color="primary" highlighted>
                {{ activosSeleccionados.length }} activo{{ activosSeleccionados.length !== 1 ? 's' : '' }} seleccionado{{ activosSeleccionados.length !== 1 ? 's' : '' }}
              </mat-chip>
            </mat-chip-set>
          </div>
          <mat-error *ngIf="requiereSeleccionActivos() && activosSeleccionados.length === 0" style="font-size: 12px;">
            Debe seleccionar al menos un activo fijo para servicios preventivos
          </mat-error>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Tipo de Servicio *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tipo de Servicio</mat-label>
            <input type="text"
                   matInput
                   formControlName="tipoServicioId"
                   [matAutocomplete]="autoTipoServicio"
                   (focus)="onTipoServicioFocus()"
                   (input)="filtrarTipoServicio($event)">
            <mat-autocomplete #autoTipoServicio="matAutocomplete" [displayWith]="displayTipoServicioFn">
              <mat-option *ngFor="let tipo of filteredTipoServicio | async" [value]="tipo.id">
                {{tipo.nombre}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="programacionForm.get('tipoServicioId')?.hasError('required')">
              El tipo de servicio es requerido
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Tipo de Solicitud (SLA) *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Seleccionar Tipo de Solicitud</mat-label>
            <mat-select formControlName="tipoSolicitudId" placeholder="Seleccionar Tipo de Solicitud">
              <mat-option *ngFor="let sla of slas" [value]="sla.id">
                {{ sla.nombre }} {{ sla.sla_dias ? '(' + sla.sla_dias + ' días)' : '' }}
              </mat-option>
            </mat-select>
            @if (programacionForm.get('tipoSolicitudId')?.touched && programacionForm.get('tipoSolicitudId')?.invalid) {
            <mat-error>
              El tipo de solicitud (SLA) es mandatorio
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="!(esGruman && isReadOnly)">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Especialidad *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Especialidad</mat-label>
            <input type="text"
                   placeholder="Seleccionar Especialidad"
                   matInput
                   formControlName="especialidadId"
                   [matAutocomplete]="autoEspecialidad"
                   (focus)="onEspecialidadFocus()"
                   (input)="filtrarEspecialidades($event)">
            <mat-autocomplete #autoEspecialidad="matAutocomplete" 
                            [displayWith]="displayEspecialidadFn"
                            [autoActiveFirstOption]="true"
                            (opened)="onEspecialidadFocus()">
              <mat-option *ngFor="let esp of filteredEspecialidades | async" [value]="esp.id">
                {{ esp.nombre }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="programacionForm.get('especialidadId')?.touched && programacionForm.get('especialidadId')?.invalid">
              {{ getErrorMessage('especialidadId') }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Sector del trabajo *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-select formControlName="sectorTrabajoId" placeholder="Seleccionar Sector">
              <mat-option *ngFor="let sector of sectores" [value]="sector.id">
                {{ sector.nombre }}
              </mat-option>
            </mat-select>
            @if (programacionForm.get('sectorTrabajoId')?.touched && programacionForm.get('sectorTrabajoId')?.invalid) {
            <mat-error>
              {{ getErrorMessage('sectorTrabajoId') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Seleccionar día *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha de visita</mat-label>
            <input matInput 
                   [matDatepicker]="picker" 
                   [min]="minDate"
                   formControlName="fechaVisita" 
                   placeholder="DD/MM/YYYY">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="programacionForm.get('fechaVisita')?.hasError('required')">
              La fecha es requerida
            </mat-error>
            <mat-error *ngIf="programacionForm.get('fechaVisita')?.hasError('matDatepickerMin')">
              La fecha no puede ser anterior a hoy
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Ticket Gruman</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Ticket Gruman</mat-label>
            <input type="text"
                   matInput
                   formControlName="ticketGruman"
                   placeholder="Ingrese ticket Gruman">
            @if (programacionForm.get('ticketGruman')?.touched && programacionForm.get('ticketGruman')?.invalid) {
            <mat-error>
              {{ getErrorMessage('ticketGruman') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Técnico *</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <input type="text"
                   placeholder="Seleccionar Técnico"
                   matInput
                   formControlName="tecnico_asignado_id"
                   [matAutocomplete]="autoTecnico1"
                   (focus)="onTecnico1Focus()"
                   (input)="filtrarTecnicos1($event)">
            <mat-autocomplete #autoTecnico1="matAutocomplete" 
                            [displayWith]="displayTecnicoFn"
                            [autoActiveFirstOption]="true"
                            (opened)="onTecnico1Focus()">
              <mat-option *ngFor="let tecnico of filteredTecnicos1 | async" [value]="tecnico.id">
                {{ tecnico.name }} {{ tecnico.lastName }}
              </mat-option>
            </mat-autocomplete>
            @if (programacionForm.get('tecnico_asignado_id')?.touched && programacionForm.get('tecnico_asignado_id')?.invalid) {
            <mat-error>
              {{ getErrorMessage('tecnico_asignado_id') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Técnico 2 (Opcional)</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <input type="text"
                   placeholder="Seleccionar Técnico 2"
                   matInput
                   formControlName="tecnico_asignado_id_2"
                   [matAutocomplete]="autoTecnico2"
                   (focus)="onTecnico2Focus()"
                   (input)="filtrarTecnicos2($event)">
            <mat-autocomplete #autoTecnico2="matAutocomplete" 
                            [displayWith]="displayTecnicoFn"
                            [autoActiveFirstOption]="true"
                            (opened)="onTecnico2Focus()">
              <mat-option *ngFor="let tecnico of filteredTecnicos2 | async" [value]="tecnico.id">
                {{ tecnico.name }} {{ tecnico.lastName }}
              </mat-option>
            </mat-autocomplete>
            @if (programacionForm.get('tecnico_asignado_id_2')?.touched && programacionForm.get('tecnico_asignado_id_2')?.invalid) {
            <mat-error>
              {{ getErrorMessage('tecnico_asignado_id_2') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 d-flex align-items-center">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16">Observaciones</mat-label>
        </div>
        <div class="col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <textarea matInput formControlName="observaciones" placeholder="Ingrese observaciones" rows="4"></textarea>
            @if (programacionForm.get('observaciones')?.touched && programacionForm.get('observaciones')?.invalid) {
            <mat-error>
              {{ getErrorMessage('observaciones') }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-sm-8">
          <button mat-raised-button color="primary" type="submit" [disabled]="loading">
           
            {{ loading ? 'Enviando...' : 'Enviar' }}
          </button>
          <button mat-raised-button type="button" (click)="volver()">Volver<mat-icon>arrow_back</mat-icon></button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
